export default "__VITE_ASSET__D8ueb5cU__"